//  ----------      START   IMPORT  BLOCK       ----------
//  Widget
import ProUserManual from "../../Widgets/Professional/ProUserManual/ProUserManual";
//  ----------      START   IMPORT  BLOCK       ----------


const HelpProManual = () => {
  return (
  <ProUserManual/>
  );
};

export default HelpProManual;